<template>
    <div class="v-overview">
        <Header></Header>
        <div class="v-overview__content container">
            <Overview class="mt--4"></Overview>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>

    import Footer from '@/components/footer.vue'
    import Header from '@/components/header.vue'
    import Navigation from "@/components/navigation";

    import Overview from "@/components/success/overview"

    export default {
        components:{
            Footer,
            Header,
            Navigation,
            Overview
        }
    }
</script>
<style lang="scss">
    .v-overview{
        &__content{
            min-height: 90vh;
        }
    }
</style>